import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';
import {SEARCH_REQUEST_PAGE_LIMIT, SearchList} from '../../../../models/search-list.model';
import {DatatableColumn} from './models/datatable-column.model';
import {SearchQueryParams} from '../../../../models/search-query-params.model';
import {SearchOrder} from '../../../../enums/search-order.enum';

@Component({
    selector: 'app-datatable',
    templateUrl: './datatable.component.html',
    styleUrls: ['./datatable.component.less']
})
export class DatatableComponent {
    @Input() columns: DatatableColumn[];
    @Input() rowTemplate: TemplateRef<any> = null;
    @Input() list: SearchList<any> = null;
    @Input() disableEllipsis = false;
    @Output() queryParamsChange: EventEmitter<SearchQueryParams> = new EventEmitter<SearchQueryParams>();

    requestPageLimit = SEARCH_REQUEST_PAGE_LIMIT;
    orderByField: string;
    orderDirection: SearchOrder;

    onQueryParamsChange(event) {
        const {sort} = event;
        const sortByItem = sort.find(item => !!item.value);
        if (sortByItem) {
            const orderByField = sortByItem?.key;
            const orderDirection = sortByItem?.value === 'ascend'
                ? SearchOrder.ASC
                : sortByItem?.value === 'descend'
                    ? SearchOrder.DESC
                    : undefined;
            if (
                this.orderByField !== orderByField
                || this.orderDirection !== orderDirection
            ) {
                this.orderByField = orderByField;
                this.orderDirection = orderDirection;
                this.queryParamsChange.emit(new SearchQueryParams({orderByField, orderDirection}));
            }
        } else {
            this.queryParamsChange.emit();
        }
    }

    get showLimitedResultsLabel() {
        return !this.list?.loading && this.list?.items?.length === SEARCH_REQUEST_PAGE_LIMIT;
    }

    getSortOrder(columnKey: string) {
        return columnKey && columnKey === this.list?.queryParams?.orderByField
            ? this.list?.queryParams?.orderDirection === SearchOrder.ASC ? 'ascend' : 'descend'
            : undefined;
    }
}
